import { isNonNullable, isNumber, isString } from "../type-guards";
export class ArrayUtils {
    static groupBy = (array, getKey, getValue) => array.reduce((map, cur) => {
        const key = getKey(cur);
        const value = (getValue ? getValue(cur) : cur);
        const list = map.get(key);
        if (list)
            list.push(value);
        else
            map.set(key, [value]);
        return map;
    }, new Map());
    static toKeyMap = (array, getKey, getValue) => array.reduce((map, cur) => {
        const key = getKey(cur);
        const value = (getValue ? getValue(cur) : cur);
        map.set(key, value);
        return map;
    }, new Map());
    /** 2次元配列の任意の場所に値をセット */
    static setTo2d = (array, value, rowIndex, columnIndex) => {
        const row = [...(array[rowIndex] ?? [])];
        row[columnIndex] = value;
        const next = [...array];
        next[rowIndex] = row;
        return next;
    };
    /**
     * 1:Nの関係のデータをフラットにする
     */
    static flatGroup = (parents, children, getParentKey, convertToParentKey) => {
        const childByParentKey = this.groupBy(children, convertToParentKey);
        return parents.flatMap((parent) => {
            const children = childByParentKey.get(getParentKey(parent)) ?? [];
            return children.map((child) => [child, parent]);
        });
    };
    static sortByProperty = (array, sort = "asc", getPropertyValue) => {
        return [...array].sort((a, b) => {
            const sortDirection = sort === "asc" ? 1 : -1;
            const aValue = getPropertyValue(a);
            const bValue = getPropertyValue(b);
            const getPriority = (v) => {
                return isNumber(v) ? 1 : isString(v) ? 2 : 3;
            };
            const aPriority = getPriority(aValue);
            const bPriority = getPriority(bValue);
            if (aPriority !== bPriority) {
                return (aPriority - bPriority) * sortDirection;
            }
            if (isNumber(aValue) && isNumber(bValue)) {
                return (aValue - bValue) * sortDirection;
            }
            if (isString(aValue) && isString(bValue)) {
                return aValue.localeCompare(bValue) * sortDirection;
            }
            return 0;
        });
    };
    static sortWithOrder(array, order, getKey = (e) => e.id) {
        const elementMap = ArrayUtils.toKeyMap(array, getKey);
        const elementsWithOrder = order
            .map((id) => elementMap.get(id))
            .filter(isNonNullable);
        const entitiesWithoutOrder = array.filter((e) => !order.includes(getKey(e)));
        return [...elementsWithOrder, ...entitiesWithoutOrder];
    }
}
//# sourceMappingURL=array-utils.js.map